export default "__VITE_ASSET__1de42f33__"